import { useTranslation } from 'react-i18next'
import { useActiveLoanForBook, useReturnLoan } from '@/hooks/loans'
import type { Book } from '@/types'

interface BookLoanMenuItemsProps {
  book: Book
  onLend: () => void
  onDone: () => void
}

/** Quick-action menu entries: lend an owned book, or mark an active loan as returned */
export function BookLoanMenuItems({ book, onLend, onDone }: BookLoanMenuItemsProps) {
  const { t } = useTranslation()
  const loan = useActiveLoanForBook(book.id)
  const returnLoan = useReturnLoan()
  const itemClass =
    'w-full px-3 py-2 text-left text-sm hover:bg-muted/20 flex items-center gap-2 transition-colors text-foreground'

  if (loan) {
    return (
      <button
        type="button"
        className={itemClass}
        disabled={returnLoan.isPending}
        onClick={async () => {
          await returnLoan.mutateAsync(loan)
          onDone()
        }}
      >
        <span aria-hidden="true">↩️</span>
        {t('loans.markReturned')}
      </button>
    )
  }

  if (book.ownership === 'borrowed' || book.status === 'wishlist') return null

  return (
    <button
      type="button"
      className={itemClass}
      onClick={() => {
        onLend()
        onDone()
      }}
    >
      <span aria-hidden="true">📤</span>
      {t('loans.lend')}
    </button>
  )
}
